import login from "./login";
import vehicle from "./vehicle";
export default {
  login,
  vehicle,
};
